import { useState } from "react";
import { NavLink } from "react-router"

import {
    UserCircle,
    LogOut,
    Menu,
    X,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Header(props) {
    const {
        setMobileOpenLay
    } = props
    const [profileOpen, setProfileOpen] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const { user, logout } = useAuth();
    const MobileHandle = () => {
        setMobileOpen(!mobileOpen)
        setMobileOpenLay(!mobileOpen)
    }
    const logouts = () => {
        logout()
        setProfileOpen(false);
    }
    

    return (
        <header className="w-full bg-white shadow flex items-center justify-between px-4 md:px-6 h-14 sticky top-0 z-40">
            {/* mobile hamburger */}
            <button
                className="lg:hidden mr-2"
                onClick={() => MobileHandle()}
            >
                {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            <h1 className="text-lg font-semibold text-gray-800">Admin Logo</h1>
            <div className="relative ml-auto">
                <button
                    onClick={() => setProfileOpen(!profileOpen)}
                    className="flex items-center gap-2 focus:outline-none"
                >
                    {user ? (
                        <>
                            Hi, {user.name}<UserCircle size={28} className="text-gray-600" />
                        </>
                    ) : (
                        <UserCircle size={28} className="text-gray-600" />
                    )}

                </button>
                {profileOpen && (
                    <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg py-2 text-sm">
                        <NavLink
                            to="/profile"
                            className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-gray-700"
                            onClick={() => setProfileOpen(false)}
                        >
                            <UserCircle size={16} /> Profile
                        </NavLink>
                        <button
                            onClick={logouts}
                            // onClick={() => {
                            //     setProfileOpen(false);
                            // }}
                            className="w-full text-left flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-gray-700"
                        >
                            <LogOut size={16} /> Logout
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
}